import { TrelloStorage } from '@trello/storage';
import { reloadedFromVersionStorageKey } from './constants';

export const sendReloadedToUpdateEvent = () => {
  if (TrelloStorage.get(reloadedFromVersionStorageKey)) {
    // Make analytics call, will be addressed in
    // https://trello.atlassian.net/browse/FEPLAT-3111

    // Remove the key, so that we don't send an errant event on the next load
    TrelloStorage.unset(reloadedFromVersionStorageKey);
  }
};
